import { Component, OnInit, ViewContainerRef } from "@angular/core";
import {
  TranslateModule,
  TranslateLoader,
  TranslateService
} from "@ngx-translate/core";
import { NgxPermissionsService } from "ngx-permissions";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { environment } from "@env/environment";
import { Router, Route, NavigationEnd } from "@angular/router";
import { SettingsConstant } from "./shared/constants/settings.constants";
import { LocalStorageService } from "./shared/services/local-storage.service";
import { AuthService } from 'dlv-ng-auth';

declare let gtag: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  whitelistEnv = ["dev", "prod", "staging", "qa"];
  loginConfig = {};
  constructor(
    private translate: TranslateService,
    public router: Router,
    private permissionService: NgxPermissionsService,
    private localStorage: LocalStorageService,
    private authService: AuthService
  ) {
    authService.init({
      environment: this.whitelistEnv.includes(environment.env) ? environment.env : 'dev',
      interceptRequests: true,
      skipAuthorization: true,
      onUnauthorized: () => { },
      on401Action: () => { },
      needOtpLogin: false,
      needPasswordLogin: false
    });

    this.router.events.subscribe(event => {
      if (event['url'] == '/login-internal') {
        this.loginConfig['needGoogleLogin'] = true;
        authService.init(this.loginConfig);
      }
      if (event instanceof NavigationEnd) {
        gtag('config', environment.GA_TRACKING_ID,
          {
            'page_path': event.urlAfterRedirects
          }
        );

      }

    });
  }

  ngOnInit() {
    const locationUrl = window.location;
    const perm = this.localStorage.getItem(
      `${SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES}`
    );
    if (perm) {
      this.permissionService.loadPermissions(perm);
    }

    // 666 Redundant code 
    // if (
    //   locationUrl.hash &&
    //   (locationUrl.hash.includes("#access_token=") ||
    //     locationUrl.hash.includes("#error="))
    // ) {
    //   this.auth0Service.handleAuthentication();
    // }
    // 666 ends
    this.translate.setDefaultLang(SettingsConstant.DEFAULT_LANGUAGE);
    this.translate.use(SettingsConstant.DEFAULT_LANGUAGE);
  }
}
